import { ProductGtmEvents } from '@/gtm/product/product-gtm-events';

export class ProductReviewsGtmEvents extends ProductGtmEvents {
  clickTab({ productCode, reviewsCount }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Отзывы_Клик',
      eventLabel: `${productCode}|${reviewsCount}`,
    });
  }

  changeSort({ name, productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Отзывы_Сортировка',
      eventLabel: `${productCode}|${name}`,
    });
  }

  submitReview({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Отзывы_ОтправитьОтзыв',
      eventLabel: productCode,
    });
  }

  leaveReview({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Отзывы_ОставитьОтзыв',
      eventLabel: productCode,
    });
  }
}
